<script lang="ts">
    import { onMount } from 'svelte';
    import { fetchVideoDetails } from './fetchVideoDetails';

    import DeviceDetector from 'svelte-device-detector';
    import Desktop from './Desktop.svelte';
    import Mobile from './Mobile.svelte';
    import Cta from './Cta.svelte';
    import Box from '../_wrappers/Box.svelte';

    // Types
    import type { TransitionEffect } from '$lib/types/Theme';

    export let url = '';
    export let durationTrigger = 10;
    export let message = '';
    export let btnText = 'Click me!';
    export let btnBgColor = '#0076FF';
    export let btnColor = '#F0F0F0';
    export let onBtnClick = () => null;
    export let onBtnMouseEnter = () => null;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let box = {};

    // Video details
    let loading = true;
    let thumbnail = '';
    let ratio = 1;

    let ctaVisible = false;

    onMount(async () => {
        const videoDetails = await fetchVideoDetails(url);
        loading = false;

        thumbnail = videoDetails?.thumbnail || '';
        ratio = videoDetails?.ratio || 1;
    });

    const handleProgress = (progress: { playedSeconds: number }) => {
        if (progress.playedSeconds > durationTrigger) {
            ctaVisible = true;
        }
    };
</script>

<Box {...box} {transitionDelay} {transitionEffect}>
    <DeviceDetector showInDevice="desktop">
        <Desktop
            {loading}
            {url}
            {btnText}
            {btnBgColor}
            {btnColor}
            {onBtnClick}
            {ctaVisible}
            {thumbnail}
            onProgress={handleProgress}
        />
    </DeviceDetector>

    <DeviceDetector showInDevice="mobile">
        <Mobile
            {loading}
            {url}
            {btnText}
            {btnBgColor}
            {btnColor}
            {onBtnClick}
            {ctaVisible}
            {thumbnail}
            ratio="{ratio}%"
            onProgress={handleProgress}
        />
    </DeviceDetector>

    <Cta {btnText} {btnColor} {btnBgColor} {ctaVisible} {message} {onBtnClick} {onBtnMouseEnter} />
</Box>
